import { useUserStore } from '@/stores/user';
import config from '@/config';

export function configurationPaySafe(total: number, accountId: number, environment: string) {
    const user = useUserStore();
    const paysafeEnv = `${environment === 'PRODUCTION' ? 'LIVE' : 'TEST'}`;
    console.log('Paysafe environment', paysafeEnv);

    let options = {
        amount: total,
        currency: 'EUR',
        locale: 'en_US',
        environment: paysafeEnv,
        merchantRefNum: `${user.account.id}-${Math.floor(Date.now() / 1000)}`,
        customer: {
            firstName: user.account.username,
            email: user.account.email,
            lastName: 'Doe'
        },
        canEditAmount: false,
        displayPaymentMethods: ['card'],
        paymentMethodDetails: {
            card: {
                accountId: accountId
            }
        },
        threeDs: {
            merchantUrl: `${config.FullApiUrl}payment`,
            deviceChannel: 'BROWSER',
            messageCategory: 'PAYMENT',
            transactionIntent: 'GOODS_OR_SERVICE_PURCHASE',
            authenticationPurpose: 'PAYMENT_TRANSACTION'
        }
    };
    return options;
}
